import type { FC } from 'react';

import { redirectTo } from '@xing-com/crate-core-router';
import { useFeatureSwitch } from '@xing-com/hub';

import { MostVisitedCompanies } from '../most-visited-companies/most-visited-companies';

export const MostVisitedCompaniesRoute: FC = () => {
  const showNewLoggedInOverview = useFeatureSwitch(
    'enable_new_logged_in_companies_overview'
  );

  if (showNewLoggedInOverview) {
    return redirectTo('/companies');
  }

  return <MostVisitedCompanies />;
};
